import * as React from "react";

import { Icon, Modal } from "semantic-ui-react";


interface IMainViewProps{
	header?: string;
	content?: any;
}

interface IMainViewState{}

export class InfoCircle extends React.Component<IMainViewProps, IMainViewState>{
	constructor(props){
		super(props);
	}
	render(){
		return(
		<Modal trigger={<Icon name="info" className="circle info-circle"/>}>
			{this.props.header && <Modal.Header>{this.props.header}</Modal.Header>}
			<Modal.Content className="modal-content">
				{this.props.content}
				{this.props.children}
			</Modal.Content>
		</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/info-circle.tsx